(function () {
  'use strict';
  // Tap a colour dot on any card: swap the card to that colour in place.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ya-sw]');
    if (!a) return;
    var card = a.closest('.yac'); if (!card) return;
    e.preventDefault();
    if (a.classList.contains('is-on')) return;
    var d = a.dataset;
    var img = card.querySelector('.yac__img img'); if (img) { img.removeAttribute('srcset'); img.src = d.img; }
    card.querySelectorAll('a.yac__link').forEach(function (l) { l.href = d.url; });
    var nm = card.querySelector('.yac__name'); if (nm) nm.textContent = d.name;
    var pr = card.querySelector('.yac__price'); if (pr) pr.innerHTML = '<b>' + d.price + '</b>' + (d.mrp ? ' <s>' + d.mrp + '</s>' : '');
    card.setAttribute('data-handle', d.handle);
    var w = card.querySelector('[data-ya-wish]');
    if (w) { w.setAttribute('data-ya-wish', d.handle); try { var l = JSON.parse(localStorage.getItem('ya_wish') || '[]'); w.classList.toggle('is-on', l.indexOf(d.handle) > -1); } catch (x) {} }
    card.querySelectorAll('.yac__dots a').forEach(function (x) { x.classList.toggle('is-on', x === a); });
    var qa = card.querySelector('[data-ya-qa]');
    if (qa) {
      fetch('/products/' + d.handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var j = { h: p.handle, t: d.name, s: p.type, i: d.img, p: p.price, c: p.compare_at_price || 0, v: p.variants.map(function (v) { return { id: v.id, t: v.title, a: v.available, q: -1 }; }) };
        qa.setAttribute('data-sheet', JSON.stringify(j)); qa.classList.remove('is-in'); qa.textContent = 'Quick add';
      }).catch(function () {});
    }
  });
})();